import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'convfact-chips-component',
    templateUrl: './chips.component.html',
    styleUrls: ['./chips.component.scss'],
    standalone: false
})
export class ChipsComponent {
  @Input() chipsElements: [{}];
  @Input() changeFunction: Function;
  @Input() container: Object;

  @Output() deletedItemEvent = new EventEmitter<string>();

  constructor() { }

  addChip() {
  }

  deleteChip(element) {
    const index = this.chipsElements.indexOf(element);
    this.chipsElements.splice(index, 1);

    this.deletedItemEvent.emit('Eliminado');
  }

  public trackByIndex(i: number) { return i; }

}
